import _defineProperty from "E:/workSpacke/screening-sys/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _ref;
/** When your routing table is too long, you can split it into small modules**/

import Layout from "@/layout";
var govRouter = [{
  path: "/",
  name: "workbench",
  component: Layout,
  children: [{
    path: "workbench",
    component: function component() {
      return import("@/views/gov/workbench");
    },
    meta: {
      title: "工作台",
      icon: "nav_workbench",
      roles: ["province", "city", "district", "province_03", "city_03", "district_03"]
    }
  }]
},
// {
//   path: '/',
//   name: 'workbenchcity',
//   component: Layout,
//   children: [
//     {
//       path: 'workbenchcity',
//       component: () => import('@/views/gov/workbenchcity'),
//       meta: { title: '数据分析', icon: 'nav_data', roles: ['city'] },
//     }
//   ]
// },
// {
//   path: '',
//   component: Layout,
//   children: [
//     {
//       path: '/gov/aera',
//       name: 'district',
//       component: () => import('@/views/gov/report/district'),
//       meta: { title: '数据分析', icon: 'nav_data', roles: ['district'] },

//     }
//   ]
// },
{
  path: "/gov/infor",
  name: "infor",
  component: Layout,
  hidden: true,
  meta: {
    title: "辖区数据",
    icon: "account",
    roles: ["province", "city", "district", "superadmin", "province_03", "city_03", "district_03"]
  },
  children: [{
    path: "information",
    component: function component() {
      return import("@/views/gov/infor/information");
    },
    meta: {
      title: "辖区数据总览",
      icon: "home"
    }
  }, {
    path: "informationschooldetail",
    component: function component() {
      return import("@/views/gov/infor/informationschooldetail");
    },
    meta: {
      title: "辖区数据详情",
      icon: "home"
    }
  }, {
    path: "informationscreendetail",
    component: function component() {
      return import("@/views/gov/infor/informationscreendetail");
    },
    meta: {
      title: "辖区数据详情",
      icon: "home"
    }
  }]
},
// 数据分析
// {
//   path: "/",
//   name: "govdatareport",
//   component: Layout,
//   meta: { title: "数据分析", icon: "nav_data", roles: ["province", "province_03"] },
//   children: [
//     {
//       path: "govvision",
//       component: () => import("@/views/gov/data/govvision"),
//       meta: { title: "视力分析" }
//     },
//     {
//       path: "govillness",
//       component: () => import("@/views/gov/data/govillness"),
//       meta: { title: "常见病分析" }
//     },
//     // {
//     //   path: 'govinspection',
//     //   component: () => import('@/views/gov/report/data/provinceinspection'),
//     //   meta: { title: '行为影响因素监测', },
//     // },

//     // {
//     //   path: "childeyecare",
//     //   component: () => import("@/views/gov/data/childeyecare"),
//     //   meta: { title: "0-6岁视力分析", roles: ["province"] }
//     // },
//     // {
//     //   path: 'govdisease',
//     //   component: () => import('@/views/gov/report/data/provincedisease'),
//     //   meta: { title: '学生因病缺课监测', roles: ["province"] },
//     // },
//     // {
//     //   path: 'govsanitation',
//     //   component: () => import('@/views/gov/report/data/provincesanitation'),
//     //   meta: { title: '学校卫生工作情况监测', roles: ["province"] },
//     // },
//     // {
//     //   path: 'govhealth',
//     //   component: () => import('@/views/gov/report/data/provincehealth'),
//     //   meta: { title: '教学生活环境卫生监测', roles: ["province"] },
//     // }
//   ]
// },
// {
//   path: "/",
//   name: "citydatareport",
//   component: Layout,
//   meta: { title: "数据分析", icon: "nav_data", roles: ["city", "city_03"] },
//   children: [
//     {
//       path: "cityvision",
//       component: () => import("@/views/gov/report/data/city"),
//       meta: { title: "视力分析" }
//     },
//     {
//       path: "cityillness",
//       component: () => import("@/views/gov/report/data/cityilless"),
//       meta: { title: "常见病分析" }
//     },
//     // {
//     //   path: 'cityinspection',
//     //   component: () => import('@/views/gov/report/data/cityinspection'),
//     //   meta: { title: '行为影响因素监测', },
//     // },
//     // {
//     //   path: 'citydisease',
//     //   component: () => import('@/views/gov/data/citydisease'),
//     //   meta: { title: '学生因病缺课监测', },
//     // },

//     // {
//     //   path: "childeyecare",
//     //   component: () => import("@/views/gov/report/data/childeyecare"),
//     //   meta: { title: "0-6岁视力分析", roles: ["city"] }
//     // },
//     // {
//     //   path: 'citydisease',
//     //   component: () => import('@/views/gov/report/data/citydisease'),
//     //   meta: { title: '学生因病缺课监测', roles: ["city"] },
//     // },
//     // {
//     //   path: 'citysanitation',
//     //   component: () => import('@/views/gov/data/citysanitation'),
//     //   meta: { title: '学校卫生工作情况监测', roles: ["city"] },
//     // },
//     // {
//     //   path: 'cityhealth',
//     //   component: () => import('@/views/gov/data/cityhealth'),
//     //   meta: { title: '教学生活环境卫生监测', roles: ["city"] },
//     // }
//   ]
// },
// {
//   path: "/",
//   name: "disdatareport",
//   component: Layout,
//   meta: { title: "数据分析", icon: "nav_data", roles: ["district", "district_03"] },
//   children: [
//     {
//       path: "district",
//       component: () => import("@/views/gov/report/data/district"),
//       meta: { title: "视力分析" }
//     },
//     {
//       path: "districtill",
//       component: () => import("@/views/gov/report/data/districtill"),
//       meta: { title: "常见病分析" }
//     },
//     // {
//     //   path: 'districtinspection',
//     //   component: () => import('@/views/gov/report/data/districtinspection'),
//     //   meta: { title: '行为影响因素监测', },
//     // },

//     // {
//     //   path: "childeyecare",
//     //   component: () => import("@/views/gov/report/data/districtchildeyecare"),
//     //   meta: { title: "0-6岁视力分析", roles: ["district"] }
//     // },
//     // {
//     //   path: 'districtdisease',
//     //   component: () => import('@/views/gov/report/data/districtdisease'),
//     //   meta: { title: '学生因病缺课监测', roles: ["district"] },
//     // },
//     // {
//     //   path: 'districtsanitation',
//     //   component: () => import('@/views/gov/report/data/districtsanitation'),
//     //   meta: { title: '学校卫生工作情况监测', roles: ["district"] },
//     // },
//     // {
//     //   path: 'districthealth',
//     //   component: () => import('@/views/gov/report/data/districthealth'),
//     //   meta: { title: '教学生活环境卫生监测', roles: ["district"] },
//     // }
//   ]
// },

//数据可视化
{
  path: "/gov",
  name: "govdatavision",
  component: Layout,
  meta: {
    title: "数据可视化",
    icon: "nav_data",
    roles: ["province"]
  },
  children: [{
    path: "provincevision",
    component: function component() {
      return import("@/views/gov/vision/provinceSurvey");
    },
    meta: {
      title: "学生重点常见病监测"
    }
  }]
}, {
  path: "/gov",
  name: "citydatavision",
  component: Layout,
  meta: {
    title: "数据可视化",
    icon: "nav_data",
    roles: ["city"]
  },
  children: [{
    path: "cityvision",
    component: function component() {
      return import("@/views/gov/vision/citySurvey");
    },
    meta: {
      title: "学生重点常见病监测"
    }
  }]
}, {
  path: "/gov",
  name: "districtdatavision",
  component: Layout,
  meta: {
    title: "数据可视化",
    icon: "nav_data",
    roles: ["district"]
  },
  children: [
  // {
  //   path: "healthwork",
  //   component: () => import("@/views/gov/vision/components/schoolHealthWork"),
  //   meta: { title: "学校卫生工作" }
  // },
  {
    path: "districtvision",
    component: function component() {
      return import("@/views/gov/vision/districtSurvey");
    },
    meta: {
      title: "学生重点常见病监测"
    }
  }]
},
// 常见病监测
{
  path: "/gov/functionally",
  name: "govfunctionally",
  component: Layout,
  meta: {
    title: "常见病监测",
    icon: "nav_func",
    roles: ["province", "city", "district", "province_03", "city_03", "district_03"]
  },
  children: [{
    path: "project",
    component: function component() {
      return import("@/views/gov/survey/manage/projectmanage");
    },
    meta: {
      title: "项目管理",
      roles: ["province_03"]
    }
  }, {
    path: 'cityfile',
    component: function component() {
      return import('@/views/gov/manage/cityfile');
    },
    meta: {
      title: '筛查管理',
      roles: ['city', "city_03"]
    }
  }, {
    path: 'index',
    component: function component() {
      return import('@/views/gov/manage/index');
    },
    meta: {
      title: '筛查管理',
      roles: ['district', "district_03"]
    }
  }, {
    path: "progress",
    component: function component() {
      return import("@/views/gov/progress");
    },
    meta: {
      title: "筛查进度",
      roles: ["province", "province_03"]
    }
  }, {
    path: "progress",
    component: function component() {
      return import("@/views/gov/progresscity");
    },
    meta: {
      title: "筛查进度",
      roles: ["city", "city_03"]
    }
  }, {
    path: "progressdistrict",
    component: function component() {
      return import("@/views/gov/progressdistrict");
    },
    meta: {
      title: "筛查进度",
      roles: ["district", "district_03"]
    }
  }, {
    path: "assess",
    component: function component() {
      return import("@/views/screen/assess/index");
    },
    meta: {
      title: "质量控制"
    }
  }, {
    path: "contrast",
    component: function component() {
      return import("@/views/gov/contrast");
    },
    meta: {
      title: "抽样对比",
      roles: ["province", "city", "district", "screen", "province_03", "city_03", "district_03"]
    }
  }, {
    path: "export",
    component: function component() {
      return import("@/views/gov/export");
    },
    meta: {
      title: "导出数据",
      roles: ["province", "city", "district", "province_03", "city_03", "district_03"]
    }
  },
  //新增远视力管理机构使用
  {
    path: "govimports",
    component: function component() {
      return import("@/views/gov/gov-imports");
    },
    meta: {
      title: "数据文件导入",
      roles: ["province_03", "city_03", "district_03"]
    }
  }]
},
// 调查问卷
{
  path: "/gov/questionably",
  name: "questionably",
  component: Layout,
  meta: {
    title: "调查问卷",
    icon: "nav_ques",
    roles: ["province", "city", "district", "province_03", "city_03", "district_03"]
  },
  children: [{
    path: "questionnaire",
    component: function component() {
      return import("@/views/gov/questionnaire2");
    },
    meta: {
      title: "调查问卷",
      roles: ["province", "city", "district", "province_03", "city_03", "district_03"]
    }
  }]
},
// 健康干预
{
  path: "/gov/healthily",
  name: "gydataanalysis-province",
  component: Layout,
  meta: {
    title: "健康干预",
    icon: "nav_sys",
    roles: ["province"]
  },
  children: [{
    path: "provincesta",
    component: function component() {
      return import("@/views/gov/functionally/interfere/dataStatistics");
    },
    meta: {
      title: "近视干预统计"
    }
  }, {
    path: "provinceana",
    component: function component() {
      return import("@/views/gov/functionally/interfere/components/provinceAnalysis");
    },
    meta: {
      title: "近视干预分析"
    }
  }]
}, {
  path: "/gov/healthily",
  name: "gydataanalysis-city",
  component: Layout,
  meta: {
    title: "健康干预",
    icon: "nav_sys",
    roles: ["city"]
  },
  children: [{
    path: "citysta",
    component: function component() {
      return import("@/views/gov/functionally/interfere/dataStatistics");
    },
    meta: {
      title: "近视干预统计"
    }
  }, {
    path: "cityana",
    component: function component() {
      return import("@/views/gov/functionally/interfere/components/cityAnalysis");
    },
    meta: {
      title: "近视干预分析"
    }
  }]
}, {
  path: "/gov/healthily",
  name: "gydataanalysis-district",
  component: Layout,
  meta: {
    title: "健康干预",
    icon: "nav_sys",
    roles: ["district"]
  },
  children: [{
    path: "districtsta",
    component: function component() {
      return import("@/views/gov/functionally/interfere/dataStatistics");
    },
    meta: {
      title: "近视干预统计"
    }
  }, {
    path: "districtana",
    component: function component() {
      return import("@/views/gov/functionally/interfere/components/dataAnalysis");
    },
    meta: {
      title: "近视干预分析"
    }
  }]
}, {
  path: "/gov/healthily",
  name: "gydataanalysis",
  hidden: true,
  component: Layout,
  meta: {
    title: "健康干预",
    icon: "nav_sys",
    roles: ["province", "city", "district"]
  },
  children: [
  //视力数据分析
  {
    path: "province",
    component: function component() {
      return import("@/views/gov/functionally/interfere/components/provinceAnalysis");
    },
    meta: {
      title: "省级近视干预分析",
      roles: ["province", "district"]
    }
  }, {
    path: "city",
    component: function component() {
      return import("@/views/gov/functionally/interfere/components/cityAnalysis");
    },
    meta: {
      title: "市级近视干预分析",
      roles: ["province", "city", "district"]
    }
  }, {
    path: "district",
    component: function component() {
      return import("@/views/gov/functionally/interfere/components/dataAnalysis");
    },
    meta: {
      title: "区/县级近视干预分析",
      roles: ["province", "city", "district"]
    }
  }]
},
// region 健康干预工作
{
  path: "/gov/healthily-work",
  name: "gydataanalysis-ai",
  component: Layout,
  meta: {
    title: "健康干预工作",
    icon: "nav_sys",
    roles: ["province", "city", "district"]
  },
  children: [{
    path: "gysetting",
    component: function component() {
      return import("@/views/gov/gywork/gySetting");
    },
    meta: {
      title: "健康干预工作设置"
    }
  }, {
    path: "gyfile",
    component: function component() {
      return import("@/views/gov/gywork/gyFile");
    },
    meta: {
      title: "健康干预档案管理"
    }
  }, {
    path: "gyinform",
    component: function component() {
      return import("@/views/gov/gywork/gyInform");
    },
    meta: {
      title: "AI预警通知设置"
    }
  },
  // {
  //   path: "gyanaly",
  //   component: () => import("@/views/gov/functionally/interfere/components/provinceAnalysis"),
  //   meta: { title: "健康干预效果分析" }
  // }
  {
    path: "sub",
    component: function component() {
      return import("@/views/gov/gywork/components/gySub");
    },
    hidden: true,
    meta: {
      title: "订阅相关"
    }
  }, {
    path: "inform",
    component: function component() {
      return import("@/views/gov/gywork/components/gyInform");
    },
    hidden: true,
    meta: {
      title: "推送与通知"
    }
  }, {
    path: "ques",
    component: function component() {
      return import("@/views/gov/gywork/components/gyQues");
    },
    hidden: true,
    meta: {
      title: "调查问卷"
    }
  }, {
    path: "sight",
    component: function component() {
      return import("@/views/gov/gywork/components/gySight");
    },
    hidden: true,
    meta: {
      title: "视力自测与监测"
    }
  }]
},
// endregion 健康干预工作

// 传染病监测
{
  path: "/gov/pestilently",
  name: "pestilently",
  component: Layout,
  meta: {
    title: "传染病监测",
    icon: "nav_pes",
    // roles: ["province", "city", "district", "province_03", "city_03", "district_03"]
    roles: ["city", "district"]
  },
  children: [{
    path: "management",
    component: function component() {
      return import("@/views/school/checks/district/management");
    },
    meta: {
      title: "晨午检报告",
      roles: ["district"]
    }
  }, {
    path: "cityManagement",
    component: function component() {
      return import("@/views/school/checks/city/management");
    },
    meta: {
      title: "晨午检报告",
      roles: ["city"]
    }
  }, {
    path: "cityForDistrictManagement",
    component: function component() {
      return import("@/views/school/checks/district/management");
    },
    hidden: true,
    meta: {
      title: "晨午检报告",
      roles: ["city", "district"]
    }
  }, {
    path: "statisticAnalysis",
    component: function component() {
      return import("@/views/school/statisticAnalysis");
    },
    meta: {
      title: " 健康状况查询 ",
      roles: ["city", "district"]
    }
  }, {
    path: "cityForStatisticAnalysis",
    component: function component() {
      return import("@/views/school/statisticAnalysis/city");
    },
    hidden: true,
    meta: {
      title: " 健康状况查询 ",
      roles: ["city", "district"]
    }
  }, {
    path: "districtForStatisticAnalysis",
    component: function component() {
      return import("@/views/school/statisticAnalysis/district");
    },
    hidden: true,
    meta: {
      title: " 健康状况查询 ",
      roles: ["city", "district"]
    }
  }, {
    path: "schoolForStatisticAnalysis",
    component: function component() {
      return import("@/views/school/statisticAnalysis/school");
    },
    hidden: true,
    meta: {
      title: " 健康状况查询 ",
      roles: ["city", "district"]
    }
  }, {
    path: "classForStatisticAnalysis",
    component: function component() {
      return import("@/views/school/statisticAnalysis/class");
    },
    hidden: true,
    meta: {
      title: " 健康状况查询 ",
      roles: ["city", "district"]
    }
  },
  // {
  //   path: 'infectiousWarning',
  //   component: () => import('@/views/school/infectiousWarning'),
  //   meta: { title: '疫情预警', roles: ["province", "district"] }
  // },
  {
    path: 'infectiousWarningCity',
    component: function component() {
      return import('@/views/school/infectiousWarningCity');
    },
    meta: {
      title: '疫情预警',
      roles: ["city"]
    }
  }]
},
//系统功能
{
  path: "/gov/systematically",
  name: "systematically",
  component: Layout,
  meta: {
    title: "系统功能",
    icon: "nav_sys",
    roles: ["province", "city", "district", "province_03", "city_03", "district_03"]
  },
  children: [{
    path: "manage",
    component: function component() {
      return import("@/views/gov/functionally/manage");
    },
    meta: {
      title: "账号管理",
      roles: ["province", "city", "district", "province_03", "city_03", "district_03"]
    }
  }, {
    path: "notify",
    component: function component() {
      return import("@/views/gov/notify");
    },
    meta: {
      title: "消息中心",
      roles: ["province", "city", "district"]
    }
  }, {
    path: "operationlog",
    component: function component() {
      return import("@/views/gov/operationlog");
    },
    meta: {
      title: "操作日志",
      roles: ["province", "city", "district"]
    }
  }, {
    path: "task",
    component: function component() {
      return import("@/views/gov/task");
    },
    meta: {
      title: "发送通知",
      roles: ["province", "city", "district", "province_03", "city_03", "district_03"]
    }
  }, {
    path: "helpcenter",
    component: function component() {
      return import("@/views/screen/helpcenter");
    },
    meta: {
      title: "帮助中心",
      roles: ["province", "city", "district"]
    }
  }]
},
// 侧边栏未改动前
// {
//   path: "/gov/functionally",
//   name: "govfunctionally",
//   component: Layout,
//   meta: {
//     title: "常用功能",
//     icon: "nav_functive",
//     roles: ["province", "city", "district", "province_03", "city_03", "district_03"]
//   },
//   children: [
//     {
//       path: "manage",
//       component: () => import("@/views/gov/functionally/manage"),
//       meta: { title: "账号管理", roles: ["province", "city", "district", "province_03", "city_03", "district_03"] }
//     },
//     // {
//     //   path: 'sendnotify',
//     //   component: () => import('@/views/gov/sendnotify'),
//     //   meta: { title: '任务管理', roles: ['province', 'city','district', 'superadmin'] }
//     // },
//     {
//       path: "task",
//       component: () => import("@/views/gov/task"),
//       meta: { title: "任务管理", roles: ["province", "city", "district", "province_03", "city_03", "district_03"] }
//     },
//     {
//       path: "project",
//       component: () => import("@/views/gov/survey/manage/projectmanage"),
//       meta: { title: "项目管理", roles: ["province_03"] }
//     },
//     {
//       path: "questionnaire",
//       component: () => import("@/views/gov/questionnaire2"),
//       meta: { title: "调查问卷", roles: ["province", "city", "district", "province_03", "city_03", "district_03"] }
//     },
//     {
//       path: "progress",
//       component: () => import("@/views/gov/progress"),
//       meta: { title: "筛查进度", roles: ["province", "province_03", "city_03", "district_03"] }
//     },
//     {
//       path: 'cityfile',
//       component: () => import('@/views/gov/manage/cityfile'),
//       meta: { title: '筛查管理', roles: ['city', "city_03"] }
//     },
//     {
//       path: 'index',
//       component: () => import('@/views/gov/manage/index'),
//       meta: { title: '筛查管理', roles: ['district', "district_03"], }
//     },
//     {
//       path: "progress",
//       component: () => import("@/views/gov/progresscity"),
//       meta: { title: "筛查进度", roles: ["city", "city_03"] }
//     },
//     {
//       path: "progressdistrict",
//       component: () => import("@/views/gov/progressdistrict"),
//       meta: { title: "筛查进度", roles: ["district", "district_03"] }
//     },
//     {
//       path: "assess",
//       component: () => import("@/views/screen/assess/index"),
//       meta: { title: "质量控制" }
//     },
//     {
//       path: "contrast",
//       component: () => import("@/views/gov/contrast"),
//       meta: {
//         title: "抽样对比",
//         roles: ["province", "city", "district", "screen", "province_03", "city_03", "district_03"]
//       }
//     },
//     {
//       path: "export",
//       component: () => import("@/views/gov/export"),
//       meta: { title: "导出数据", roles: ["province", "city", "district", "province_03", "city_03", "district_03"] }
//     },
//     {
//       path: 'infectiousWarningCity',
//       component: () => import('@/views/school/infectiousWarningCity'),
//       meta: { title: '疫情预警', roles: ["city"] }
//     },
//     {
//       path: "management",
//       component: () => import("@/views/school/checks/district/management"),
//       meta: { title: "晨午检报告", roles: ["district"] }
//     },
//     {
//       path: "cityManagement",
//       component: () => import("@/views/school/checks/city/management"),
//       meta: { title: "晨午检报告", roles: ["city"] }
//     },
//     {
//       path: "cityForDistrictManagement",
//       component: () => import("@/views/school/checks/district/management"),
//       hidden: true,
//       meta: { title: "晨午检报告", roles: ["city", "district"] }
//     },
//     {
//       path: "statisticAnalysis",
//       component: () => import("@/views/school/statisticAnalysis"),
//       meta: { title: " 健康状况查询 ", roles: ["city", "district"] }
//     },

//     {
//       path: "cityForStatisticAnalysis",
//       component: () => import("@/views/school/statisticAnalysis/city"),
//       hidden: true,
//       meta: { title: " 健康状况查询 ", roles: ["city", "district"] }
//     },
//     {
//       path: "districtForStatisticAnalysis",
//       component: () => import("@/views/school/statisticAnalysis/district"),
//       hidden: true,
//       meta: { title: " 健康状况查询 ", roles: ["city", "district"] }
//     },
//     {
//       path: "schoolForStatisticAnalysis",
//       component: () => import("@/views/school/statisticAnalysis/school"),
//       hidden: true,
//       meta: { title: " 健康状况查询 ", roles: ["city", "district"] }
//     },
//     {
//       path: "classForStatisticAnalysis",
//       component: () => import("@/views/school/statisticAnalysis/class"),
//       hidden: true,
//       meta: { title: " 健康状况查询 ", roles: ["city", "district",] }
//     },
//     {
//       path: "notify",
//       component: () => import("@/views/gov/notify"),
//       meta: { title: "消息中心", roles: ["province", "city", "district"] }
//     },
//     {
//       path: "operationlog",
//       component: () => import("@/views/gov/operationlog"),
//       meta: { title: "操作日志", roles: ["province", "city", "district"] }
//     },
//     // {
//     //   path: 'assessschool',
//     //   hidden: true,
//     //   component: () => import('@/views/screen/assessschool'),
//     //   meta: { title: '质量控制',roles: ['province', 'city', 'district','screen'] }
//     // },
//     // {
//     //   path: 'export',
//     //   component: () => import('@/views/gov/manage/export'),
//     //   meta: { title: '下载文件',roles: ['district'] }
//     // },
//     {
//       path: "helpcenter",
//       component: () => import("@/views/screen/helpcenter"),
//       meta: { title: "帮助中心", roles: ["province", "city", "district"] }
//     },
//     // {
//     //   path: 'checksetting',
//     //   component: () => import('@/views/gov/checksetting'),
//     //   meta: { title: '检查项目设置',roles: ['province', 'city', 'district', 'superadmin'] }
//     // },
//     // {
//     //   path: "questionnairedoc",
//     //   component: () => import("@/views/school/checks/questionnairedoc"),
//     //   meta: { title: "监测调查问卷", roles: ['district'] }
//     // },
//     // {
//     //   path: 'infectiousWarning',
//     //   component: () => import('@/views/school/infectiousWarning'),
//     //   meta: { title: '疫情预警', roles: ["district", "province"] }
//     // },
//     {
//       path: "/setting/notificationManage",
//       name: "notificationManage",
//       component: () => import("@/views/screen/notification-manage"),
//       meta: { title: "通知管理", roles: ["city", "district"] }
//     }
//     // {
//     //   path: "earlyWarningProcessing",
//     //   component: () => import("@/views/school/checks/district/earlyWarningProcessing"),
//     //   meta: { title: "预警处理" , roles: ['district']}
//     // },

//     // {
//     //   path: 'checksetting',
//     //   component: () => import('@/views/gov/checksetting'),
//     //   meta: { title: '检查项目设置',roles: ['province', 'city', 'district', 'superadmin'] }
//     // },
//     // {
//     //   path: 'set',
//     //   component: () => import('@/views/gov/set'),
//     //   meta: { title: '检查项目设置',icon: 'ope',roles: ['province', 'city', 'district', 'superadmin'] }
//     // },
//   ]
// },
{
  path: '/gov/assessschoolgx',
  component: Layout,
  hidden: true,
  children: [{
    path: '',
    name: 'assessschool',
    component: function component() {
      return import('@/views/screen/assessschool');
    },
    meta: {
      title: '质量控制',
      icon: 'ope',
      roles: ['province', 'city', 'district', 'screen', 'screen_03', 'superadmin']
    }
  }]
}, {
  path: "/gov/account",
  name: "govaccount",
  component: Layout,
  hidden: true,
  meta: {
    title: "机构管理",
    icon: "account",
    roles: ["province", "city", "district", "superadmin"]
  },
  children: [{
    path: "gov",
    component: function component() {
      return import("@/views/gov/account/gov");
    },
    meta: {
      title: "管理机构账号分配",
      roles: ["province", "city"]
    }
  }, {
    path: "screen",
    component: function component() {
      return import("@/views/gov/account/screen");
    },
    meta: {
      title: "筛查机构账号分配"
    }
  }, {
    path: "subaccount",
    component: function component() {
      return import("@/views/gov/account/subaccount");
    },
    meta: {
      title: "子账号分配",
      roles: ["province", "city", "superadmin"]
    }
  }, {
    path: "govscreener",
    component: function component() {
      return import("@/views/screen/account/govscreener");
    },
    meta: {
      title: "筛查员列表",
      roles: ["province", "city", "superadmin", "district"]
    }
  }
  // {
  //   path: 'school',
  //   component: () => import('@/views/screen/account/'),
  //   meta: { title: '学校账号管理', roles: ['district'] }
  // }
  ]
},
// {
//   path: '/gov/assess',
//   component: Layout,
//   children: [
//     {
//       path: '',
//       name: 'assess',
//       component: () => import('@/views/gov/assess'),
//       meta: { title: '质量控制',icon: 'ope', roles: ['province', 'city', 'district',] }
//     },

//   ]
// },
// {
//   path: '/gov',
//   component: Layout,
//   hidden:true,
//   children: [
//     {
//       path: '/govfile',
//       name: 'gov/file',
//       component: () => import('@/views/gov/govfile'),
//       meta: { title: '学生档案', roles: ['province', 'city','district'] },

//     }
//   ]
// },
{
  path: "/gov/task",
  component: Layout,
  hidden: true,
  children: [{
    path: "",
    name: "task",
    component: function component() {
      return import("@/views/gov/task");
    },
    meta: {
      title: "任务指派",
      icon: "task",
      roles: ["province", "city", "district"]
    }
  }]
}, {
  path: "/gov/notify",
  component: Layout,
  hidden: true,
  children: [{
    path: "",
    name: "notify",
    component: function component() {
      return import("@/views/gov/notify");
    },
    meta: {
      title: "重要通知",
      icon: "notify",
      roles: ["province", "city", "district"]
    }
  }]
}, {
  path: "/gov/questionnairestatistics",
  component: Layout,
  hidden: true,
  children: [{
    path: "",
    name: "questionnairestatistics",
    component: function component() {
      return import("@/views/gov/questionnairestatistics");
    },
    meta: {
      title: "调查问卷统计",
      roles: ["province", "city", "superadmin", "district"]
    }
  }]
}, {
  path: "/gov/surveypoint",
  component: Layout,
  hidden: true,
  children: [{
    path: "",
    name: "surveypoint",
    component: function component() {
      return import("@/views/gov/survey/manage/surveypoint");
    },
    meta: {
      title: "知情同意书统计",
      roles: ["province_03"]
    }
  }]
}, {
  path: "/gov/surveyschool",
  component: Layout,
  hidden: true,
  children: [{
    path: "",
    name: "surveyschool",
    component: function component() {
      return import("@/views/gov/survey/manage/surveyschool");
    },
    meta: {
      title: "知情同意书统计",
      roles: ["province_03"]
    }
  }]
}, {
  path: "/gov/progress",
  component: Layout,
  hidden: true,
  children: [{
    path: "",
    name: "progress",
    component: function component() {
      return import("@/views/gov/progress");
    },
    meta: {
      title: "筛查进度",
      icon: "progress",
      roles: ["province", "city", "superadmin"]
    }
  }]
}, {
  path: "/gov/progress/progressdistrict",
  component: Layout,
  hidden: true,
  children: [{
    path: "",
    name: "gov/progress/progressdistrict",
    hidden: true,
    component: function component() {
      return import("@/views/gov/progressdistrict");
    },
    meta: {
      title: "筛查进度",
      icon: "progress",
      roles: ["province", "city", "district", "superadmin"]
    }
  }]
}, {
  path: "/gov/progress/progresscity",
  component: Layout,
  hidden: true,
  children: [{
    path: "",
    name: "progresscity",
    component: function component() {
      return import("@/views/gov/progresscity");
    },
    meta: {
      title: "筛查进度",
      icon: "progress",
      roles: ["province", "city", "province_03", "city_03"]
    }
  }]
}, {
  path: "/gov/progress/progressdistrict",
  component: Layout,
  hidden: true,
  children: [{
    path: "",
    name: "progressdistrict",
    component: function component() {
      return import("@/views/gov/progressdistrict");
    },
    meta: {
      title: "筛查进度",
      icon: "progress",
      roles: ["province", "city", "district", "province_03", "city_03", "district_03"]
    }
  }]
}, {
  path: "/gov/progress/progressschool",
  component: Layout,
  hidden: true,
  children: [{
    path: "",
    name: "progressschool",
    component: function component() {
      return import("@/views/gov/progressschool");
    },
    meta: {
      title: "筛查进度",
      icon: "progress",
      roles: ["province", "city", "district", "province_03", "city_03", "district_03"]
    }
  }]
}, {
  path: "/gov/contrast",
  component: Layout,
  hidden: true,
  children: [{
    path: "",
    name: "contrast",
    component: function component() {
      return import("@/views/gov/contrast");
    },
    meta: {
      title: "抽样对比",
      icon: "vs",
      roles: ["province", "city", "district"]
    }
  }]
}, {
  path: "/gov/aera",
  name: "govaeradatareport",
  hidden: true,
  component: Layout,
  meta: {
    title: "区域分析",
    icon: "chinamap",
    roles: ["province", "city", "district", "province_03", "city_03"]
  },
  children: [
  //视力数据分析
  {
    path: "province",
    component: function component() {
      return import("@/views/gov/report/data/province");
    },
    meta: {
      title: "省级数据分析",
      roles: ["province", "province_03"]
    }
  }, {
    path: "city",
    component: function component() {
      return import("@/views/gov/report/data/city");
    },
    meta: {
      title: "市级数据分析",
      roles: ["province", "city", "province_03", "city_03"]
    }
  }, {
    path: "district",
    component: function component() {
      return import("@/views/gov/report/data/district");
    },
    meta: {
      title: "区/县级数据分析",
      roles: ["province", "city", "province_03", "city_03"]
    }
  }, {
    path: "district-lz",
    component: function component() {
      return import("@/views/gov/report/data/district-lz");
    },
    meta: {
      title: "区/县级数据分析",
      roles: ["province", "city", "district", "province_03", "city_03"]
    }
  },
  //常见病数据分析
  {
    path: "cityilless",
    component: function component() {
      return import("@/views/gov/report/data/cityilless");
    },
    meta: {
      title: "市级常见病数据分析",
      roles: ["province", "city", "province_03", "city_03"]
    }
  }, {
    path: "districtill",
    component: function component() {
      return import("@/views/gov/report/data/districtill");
    },
    meta: {
      title: "区/县级常见病数据分析",
      roles: ["province", "city", "province_03", "city_03"]
    }
  },
  //儿童眼保健数据分析
  {
    path: "citychildeyecare",
    component: function component() {
      return import("@/views/gov/report/data/childeyecare");
    },
    meta: {
      title: "市级儿童眼保健数据分析",
      roles: ["province", "city", "province_03", "city_03"]
    }
  }, {
    path: "districtchildeyecare",
    component: function component() {
      return import("@/views/gov/report/data/districtchildeyecare");
    },
    meta: {
      title: "区/县级儿童眼保健数据分析",
      roles: ["province", "city", "province_03", "city_03"]
    }
  }]
},
// 数据可视化
{
  path: "/gov/vision",
  name: "datavision",
  hidden: true,
  component: Layout,
  meta: {
    title: "数据可视化",
    icon: "chinamap",
    roles: ["province", "city"]
  },
  children: [{
    path: "city",
    component: function component() {
      return import("@/views/gov/vision/citySurvey");
    },
    meta: {
      title: "学生重点常见病监测",
      roles: ["province"]
    }
  }, {
    path: "district",
    component: function component() {
      return import("@/views/gov/vision/districtSurvey");
    },
    meta: {
      title: "学生重点常见病监测",
      roles: ["province", "city"]
    }
  }]
}, {
  path: "",
  component: Layout,
  hidden: true,
  children: [{
    path: "/gov/total",
    name: "govtotal",
    component: function component() {
      return import("@/views/gov/report/workbenchtotal");
    },
    meta: {
      title: "数据总览",
      roles: ["city", "province", "superadmin"]
    }
  }]
}, {
  path: "",
  component: Layout,
  hidden: true,
  children: [{
    path: "/gov/rankingofmyopia",
    name: "govrankingofmyopia",
    component: function component() {
      return import("@/views/gov/report/rankingofmyopia");
    },
    meta: {
      title: "近视率排行",
      roles: ["province", "superadmin"]
    }
  }]
}, {
  path: "",
  component: Layout,
  hidden: true,
  children: [{
    path: "/gov/rankingofmyopiacity",
    name: "govrankingofmyopiacity",
    component: function component() {
      return import("@/views/gov/report/rankingofmyopiacity");
    },
    meta: {
      title: "近视率排行",
      roles: ["city", "province", "superadmin"]
    }
  }]
},
//
{
  path: "",
  component: Layout,
  hidden: true,
  children: [{
    path: "/gov/rankingofeye",
    name: "govrankingofeye",
    component: function component() {
      return import("@/views/gov/report/rankingofeye");
    },
    meta: {
      title: "视力低下率排行",
      roles: ["province", "superadmin"]
    }
  }]
}, {
  path: "",
  component: Layout,
  hidden: true,
  children: [{
    path: "/gov/rankingofeyecity",
    name: "govrankingofeyecity",
    component: function component() {
      return import("@/views/gov/report/rankingofeyecity");
    },
    meta: {
      title: "视力低下率排行",
      roles: ["city", "province", "superadmin"]
    }
  }]
}, {
  path: "/gov/schoolprovince",
  component: Layout,
  hidden: true,
  children: [{
    path: "",
    name: "schoolprovince",
    component: function component() {
      return import("@/views/gov/schoolprovince");
    },
    meta: {
      title: "学校数据分析",
      icon: "campus",
      roles: ["province"]
    }
  }]
}, {
  path: "/gov/schoolcity",
  component: Layout,
  hidden: true,
  meta: {
    roles: ["city"]
  },
  children: [{
    path: "",
    name: "schoolcity",
    component: function component() {
      return import("@/views/gov/schoolcity");
    },
    meta: {
      title: "学校数据分析",
      icon: "campus"
    }
  }]
}, (_ref = {
  path: "/gov/schoolcity",
  component: Layout,
  hidden: true,
  meta: {
    roles: ["province"]
  }
}, _defineProperty(_ref, "hidden", true), _defineProperty(_ref, "children", [{
  path: "",
  name: "schoolcity",
  component: function component() {
    return import("@/views/gov/schoolcity");
  },
  meta: {
    title: "市级内学校数据分析",
    icon: "campus"
  }
}]), _ref), {
  path: "/gov/schoolcitydistrict",
  component: Layout,
  hidden: true,
  meta: {
    roles: ["district"]
  },
  children: [{
    path: "",
    name: "schoolcitydistrict",
    component: function component() {
      return import("@/views/gov/schoolcitydistrict");
    },
    meta: {
      title: "学校数据分析",
      icon: "campus"
    }
  }]
}, {
  path: "/gov/schoolcitydistrict",
  component: Layout,
  hidden: true,
  meta: {
    roles: ["province", "city"]
  },
  children: [{
    path: "",
    name: "schoolcitydistrict",
    component: function component() {
      return import("@/views/gov/schoolcitydistrict");
    },
    meta: {
      title: "区/县内学校数据分析",
      icon: "campus"
    }
  }]
}, {
  path: "/gov/personal",
  component: Layout,
  hidden: true,
  children: [{
    path: "",
    name: "personal",
    component: function component() {
      return import("@/views/gov/personal");
    },
    meta: {
      title: "个案数据分析",
      icon: "people",
      roles: ["province", "city", "district"]
    }
  }]
}, {
  path: "/gov/operationlog",
  component: Layout,
  hidden: true,
  children: [{
    path: "",
    name: "operationlog",
    component: function component() {
      return import("@/views/gov/operationlog");
    },
    meta: {
      title: "操作日志",
      icon: "operationlog",
      roles: ["province", "city", "district"]
    }
  }]
}, {
  path: "/gov/assess",
  component: Layout,
  hidden: true,
  children: [{
    path: "",
    name: "assess",
    component: function component() {
      return import("@/views/screen/assess/index");
    },
    meta: {
      title: "质量控制",
      icon: "ope",
      roles: ["province", "city", "district"]
    }
  }]
}

// {
//   path: '/gov/questionnaire',
//   component: Layout,
//   hidden:true,
//   children: [
//     {
//       path: '',
//       name: 'questionnaire',
//       component: () => import('@/views/gov/questionnaire2'),
//       meta: { title: '调查问卷', icon: 'questionnaire', roles: ['province',] },
//     }
//   ]
// },
];
export default govRouter;